<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">实时数据</div>
      <el-form
        class="zj-search-form"
        ref="form"
        :model="form"
        :label-width="labelWidth"
      >
        <el-row>
          <el-form-item label="动环设备">
            <el-select v-model="FsuCode" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in EquipArr"
                :key="item.DeviceId"
                :label="item.DeviceName"
                :value="item.DeviceId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="监控类别">
            <el-select v-model="type" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in typeArr"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="status" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in StatusArr"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="记录时间" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 68rem"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <div class="zj-table-container">
          <el-table
            v-loading="searching"
            element-loading-text="加载中..."
            :data="tableData"
            ref="multipleTable"
            border
            style="width: 100%"
            fixed
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="FsuCode"
              label="设备名称"
              :formatter="getDeviceShow"
            >
            </el-table-column>
            <el-table-column prop="ChannelName" label="通道名称">
            </el-table-column>
            <el-table-column prop="Type" label="监控类别" align="center">
              <template slot-scope="scope">
                <span
                  :style="{ color: scope.row.Type }"
                  v-if="scope.row.Type == 1"
                  >遥控</span
                >
                <span
                  :style="{ color: scope.row.Type }"
                  v-else-if="scope.row.Type == 2"
                  >遥调</span
                >
                <span
                  :style="{ color: scope.row.Type }"
                  v-else-if="scope.row.Type == 3"
                  >遥测</span
                >
                <span
                  :style="{ color: scope.row.Type }"
                  v-else-if="scope.row.Type == 4"
                  >遥信</span
                >
                <span
                  :style="{ color: scope.row.Type }"
                  v-else-if="scope.row.Type == 5"
                  >开关量</span
                >
              </template></el-table-column
            >
            <el-table-column
              prop="SignalCode"
              label="信号编码"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="SignalName"
              label="信号名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="MeasuredVal"
              label="测量值"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="SignalUnit"
              label="测量值单位"
              align="center"
            ></el-table-column>
            <el-table-column prop="Status" label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.Status == 0">正常</span>
                <span v-else-if="scope.row.Status == 1">一级告警</span>
                <span v-else-if="scope.row.Status == 2">二级告警</span>
                <span v-else-if="scope.row.Status == 3">三级告警</span>
                <span v-else-if="scope.row.Status == 4">四级告警</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="UpdateTime"
              label="时间"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.$index, scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import MyApis from "../../../apis";
import EqApis from "../../../../../equipment/src/apis";
export default {
  name: "EnvironmentRecords",
  controller: "UI",
  action: "EnvironmentRecords",
  props: {
    query: {
      InfoId: String,
      type: String,
      DeviceType: Number,
    },
  },
  data() {
    return {
      searching: false, // 搜索中...
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      date: [new Date(), new Date()],
      BeginTime: null,
      EndTime: null,
      isShowPop: false,
      FsuCode: null,
      type: null,
      typeArr: [
        { value: 1, name: "遥控" },
        { value: 2, name: "遥调" },
        { value: 3, name: "遥测" },
        { value: 4, name: "遥信" },
        { value: 5, name: "开关量" },
      ],
      status: null,
      StatusArr: [
        { value: 0, name: "正常" },
        { value: 1, name: "一级告警" },
        { value: 2, name: "二级告警" },
        { value: 3, name: "三级告警" },
        { value: 4, name: "四级告警" },
      ],
    };
  },
  created: function () {
    this.getEquipInfo();
  },
  mounted: function () {
    this.search();
    this.logInfo.ActionName = "动环实时数据查看";
    this.logInfo.LogMessage = "动环实时数据查看";
    this.logInfo.ModuleName = "动环管理";
    this.logInfo.PageName = "动环实时数据列表页";
    this.addOperationLog();
  },

  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    getEquipInfo() {
      let searchInfo = {
        EquipmentType: "DynamicEnvironment", //设备类型

        DeviceType: "SubSystem.DynamicEnvironment",
        DeviceTypes: [],

        PageSize: 100,
        PageIndex: 1,
      };
      new EqApis.MonitorApi()
        .GetEquipmentPagingList(searchInfo)
        .then((r) => {
          //console.log("1");
          r = r.data.Data;
          this.EquipArr = r.PageContents;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      this.searching = true;
      const that = this;
      let data = this.date;
      if (data.length > 0) {
        that.BeginTime =
          that.date == null || that.date == ""
            ? null
            : this.date[0].format("yyyy-MM-ddT00:00");
        that.EndTime =
          that.date == null || that.date == ""
            ? null
            : this.date[1].format("yyyy-MM-ddT23:59");
      }
      let searchInfo = {
        FsuCode: this.FsuCode === "" ? null : this.FsuCode, //设备名称
        // Status: parseInt(this.IsOnline), //在线是否
        // EqType: parseInt(this.DeviceType),
        // DeviceCode: this.DeviceCode,
        Type: this.type === "" ? null : this.type, //设备名称
        Status: this.status === "" ? null : this.status, //设备名称
        BeginDate: this.BeginTime,
        EndDate: this.EndTime,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.Records()
        .GetPageContentByConditions(searchInfo)
        .then((r) => {
          //console.log("1");
          this.searching = false;
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getType() {
      let that = this;
      this.config
        .getUValue("EnvironmentSubsystem:EnDeviceType", "")
        .then((d) => {
          console.log(d);
          that.DeviceTypesArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    clearsearch() {
      this.date = [new Date(), new Date()];
      this.FsuCode = null;
      this.BeginTime = null;
      this.EndTime = null;
      this.type = null;
      this.status = null;
    },
    //查看详细
    handleClick(index, row) {
      console.log(index);
      console.log(row);
      this.$router.push({
        path: "/plugin/dynEnvironment/UI/DynamicEnvRecordsInfo",
        // name: 'mallList',
        query: {
          InfoId: row.Id,
          type: "query",
        },
      });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
    getDeviceShow(row, column) {
      let that = this;
      let data = row[column.property];
      if (data) {
        let arr = that.EquipArr;
        let result = "";
        arr.forEach((item) => {
          if (item.DeviceId == data) {
            result = item.DeviceName;
          }
        });
        return result;
      }
    },
  },
};
</script>
